import { useCurrentTeamIdContext } from '../context/CurrentTeamIdContext';

export const useCurrentTeamId = () => {
    return useCurrentTeamIdContext();
};